import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0aee4378&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "~/lang/products/insurance/home-insurance/index?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20231208114810%2Fpages%2Fcompare-home-insurance%2Findex.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsInsuranceHomeInsuranceCapturePoint: require('/home/ubuntu/nuxt/bonkers/releases/20231208114810/components/products/insurance/home-insurance/capture-point.vue').default,ProductsHumanising: require('/home/ubuntu/nuxt/bonkers/releases/20231208114810/components/products/humanising.vue').default,ProductsMoreInfo: require('/home/ubuntu/nuxt/bonkers/releases/20231208114810/components/products/more-info.vue').default,SiteFeefo: require('/home/ubuntu/nuxt/bonkers/releases/20231208114810/components/site/feefo.vue').default})
